import React, { memo, useEffect, useState } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { ZfCheckbox } from '@zafire/react';

interface CheckboxCellRendererParams extends ICellRendererParams {
  isRowSelectable: (node: ICellRendererParams['node']) => boolean;
  isSelected: (node: ICellRendererParams['node']) => boolean;
  allowUnlink: boolean;
}

const CheckboxCellRenderer = memo((props: CheckboxCellRendererParams) => {
  const { node } = props;
  const [isChecked, setIsChecked] = useState(node.isSelected());
  const isRowSelectable = props.isRowSelectable(node);
  const isSelected = props.isSelected(node);

  const onSelectionChanged = () => {
    setIsChecked(node.isSelected());
  };

  useEffect(() => {
    setIsChecked(isSelected);
    node.setSelected(isSelected, false);
  }, [isSelected]);

  useEffect(() => {
    node.addEventListener('rowSelected', onSelectionChanged);
    return () => {
      node.removeEventListener('rowSelected', onSelectionChanged);
    };
  }, [node]);

  const handleChange = (event: CustomEvent<boolean>) => {
    const newCheckedState = event.detail;
    setIsChecked(newCheckedState);
    node.setSelected(newCheckedState, false);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <ZfCheckbox
        checked={isChecked}
        onCheckboxCheck={handleChange}
        disabled={!isRowSelectable && !props.allowUnlink}
        indeterminate={false}
      />
    </div>
  );
});

export default CheckboxCellRenderer;
